import React from 'react'
import { observer } from 'mobx-react'
import { Icon } from '@winnin/winnin_ui.components.icon'

import './index.scss'
import { COLORS } from 'consts'

const WarningMessage = observer(({ message }) => {
  return (
    <div className="alert-message">
      <Icon width={24} height={24} fill={COLORS.highlight} icon="alert" />
      {message}
    </div>
  )
})

WarningMessage.propTypes = {}

WarningMessage.defaultProps = {}

WarningMessage.displayName = 'WarningMessage'

export default WarningMessage
